
import moment from 'moment';

//Consulta la informacion basica de la Historia Clinica
export const getSearchClinicHistory = (dataSend, infoStateFormListClinicHistory) => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data.existe) {
                let filterPacientes = filterData(data.paciente);
                var pacientes = filterPacientes.map(paciente => {
                    paciente.id_admision = paciente.id_admision.toString();
                    paciente.fecha = moment(paciente.fecha).format("YYYY-MM-DD");
                    paciente.estado_list_form = infoStateFormListClinicHistory
                    //paciente.estado = paciente.estado;
                    return paciente;
                });
                resolve(pacientes);
            } else {
                resolve([]);
            }
        }).catch((error) => {
            console.error('Error:', error);
            reject([]);
        });
    });
}

const filterData = (data) => {
    let orderData = [];

    for (let i = 0; i < data.length; i++) {

        let nombres = "";
        if (data[i].apellido2 != null && data[i].apellido2 != "") {
            nombres = data[i].nombres + " " + data[i].apellido1 + " " + data[i].apellido2;
        }
        else {
            nombres = data[i].nombres + " " + data[i].apellido1;
        }

        let serNombre = "";
        if (data[i].servicio.servicios.length > 1) {
            for (let k = 0; k < data[i].servicio.servicios.length; k++) {
                if (data[i].servicio.servicios[k].codigo != null && data[i].servicio.servicios[k].codigo != undefined) {
                    serNombre += data[i].servicio.servicios[k].codigo;
                    if (k < data[i].servicio.servicios.length - 1) {
                        serNombre += " - ";
                    }
                }
                else if (data[i].servicio.servicios[k].cupscod != null && data[i].servicio.servicios[k].cupscod != undefined) {
                    serNombre += data[i].servicio.servicios[k].cupscod;
                    if (k < data[i].servicio.servicios.length - 1) {
                        serNombre += " - ";
                    }
                }
            }
        }
        else {
            serNombre = data[i].servicio.servicios[0] != undefined ? data[i].servicio.servicios[0].nombre : "";
        }

        orderData[i] = {
            id_historia: data[i].id_historia.toString(),
            id_admision: data[i].id_admision.toString(),
            id_cita: data[i].id_cita.toString(),
            num_documento: data[i].num_documento,
            tip_documento: data[i].tip_documento,
            nombres: nombres,
            estado: data[i].estado,
            fecha: moment(data[i].fecha).format("YYYY-MM-DD"),
            birthday: data[i].fec_nacimiento,
            studio: data[i].pertenece_estudio,
            pertenece_estudio: data[i].pertenece_estudio,
            adress: data[i].direccion,
            telephone: data[i].celular,
            acronym: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.estudio_clinico.acronimo : "",
            id_estudio: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.estudio_clinico.id_estudio : "",
            id_visita: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.visita.id_visita : "",
            tipo: data[i].pertenece_estudio ? "Sí" : "No",
            id_paciente: data[i].id_paciente,
            perfil: sessionStorage.getItem('perfil'),
            sexo: data[i].sexo,
            fecha_ingreso_completa: data[i].fecha_ingreso_completa != null ? moment(data[i].fecha_ingreso_completa).format('h:mm:ss a') : null,
            fecha_cita: data[i].fecha_cita != null ? moment(data[i].fecha_cita).format('h:mm:ss a') : null,
            destacar: false,
            servicio: data[i].servicio.servicios,
            remitente: data[i].remitente,
            ocupacion: data[i].ocupacion,
            peso: data[i].peso,
            talla: data[i].talla,
            servName: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.visita.nombre : serNombre,
            id_tecnologo: data[i].id_tecnologo,
            servicios: data[i].servicio.servicios,
            fullname: nombres,
            correctos: data[i].correctos,
            estado_medico: data[i].estado_medico,
            estado_imagenes: data[i].estado_imagenes,
            entrevista_realizada: data[i].entrevista_realizada,
            radiofarmaco_aplicado: data[i].radiofarmaco_aplicado,
            archivos: data[i].archivos,
            existen_imagenes_diagnosticas: validateDiagnosticImages(data[i].archivos, data[i].id_admision.toString()),
            canalizacion_radiofarmaco: data[i].canalizacion_radiofarmaco,
            imagenologia_aprobada: data[i].imagenologia_aprobada,
            transcripcion_finalizada: data[i].transcripcion_finalizada,
            historia_cerrada: data[i].historia_cerrada,
            imagenologia_pendiente: data[i].imagenologia_pendiente,
            transcripcion_pendiente: data[i].transcripcion_pendiente,
            estado_transcripcion: data[i].estado_transcripcion,
            riesgo_caidas: data[i].riesgo_caidas,
            requerimientos_especiales: data[i].requerimientos_especiales,
            profesional: data[i].nombre_profesional,
            id_usuario_profesional: data[i].id_usuario_profesional,
            id_admision_cita_padre: data[i].id_admision_cita_padre !== null && data[i].id_admision_cita_padre !== undefined ? data[i].id_admision_cita_padre : null,
            //id_visita: validateVisit(data[i].estudio_detalle),
            paciente_migrado: data[i].aplicativo_migrado,
            id_estudio_paciente: data[i].id_estudio_paciente,
            actividades_realizadas: data[i].actividades_realizadas,
            e_civil: data[i].e_civil,
            fecha_cita_agenda: data[i].fecha_cita != null ? moment(data[i].fecha_cita).format('YYYY-MM-DD h:mm:ss a') : null,
            fecha_ingreso_completa_admision: data[i].fecha_ingreso_completa != null ? moment(data[i].fecha_ingreso_completa).format('YYYY-MM-DD h:mm:ss a') : null,
            has_alergies: data[i].alergias_paciente,
            planName: data[i].nombre_plan,
            thirdsName: data[i].nombre_tercero,
            check_paciente: data[i].check_paciente,
            signos_vitales_realizados: data[i].signos_vitales_realizados,
            regimen_admision: data[i].regimen_admision  
        };
    }
    return orderData;
}

const validateDiagnosticImages = (dataFiles, id_admision) => {
    if (dataFiles != undefined && dataFiles != null) {
        if (dataFiles.archivos[0] != undefined && dataFiles.archivos[0] != null) {
            if (dataFiles.archivos[0].clase === "8") {
                return true;
            }
            else
            {
                return false;
            }
        }
        else {
            console.log("admisionProblema", id_admision);
            return false;
        }
    } else {
        return false;
    }
}

const validateVisit = (dataStudio) => {
    try
    {
        if(dataStudio != null && dataStudio != undefined)
        {
            let id_visita = dataStudio.detalle.visita.id_visita;
            console.log("idVisitaEstudioClinico",id_visita);
            return id_visita;
        }
        else
        {
            return null;
        }
    }
    catch(e)
    {
        console.log(e);
    }
}